export default {
  "uploading": "_uploading_h8g1i_1",
  "card": "_card_h8g1i_13"
};import "ni:sha-256;MMmjTuL_F4iCWZy3LbauPAcFl9JnZkfpCBXnsAC6vEo";